import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLabel = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#616061" fillRule="evenodd" d="M16 8 8 0H0v8l8 8zM4.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" clipRule="evenodd" />
  </svg>
);
export default SvgLabel;
